import * as React from 'react';
import styled from 'styled-components';
import { StackOrientation } from './RadioButton';
import { color, Icon, Icons } from '@starrez/starryui9';

const WrapperDiv = styled.button`
    display: inline-flex;
    padding-right: 5px;
    cursor: pointer;
    height: 30px;
    align-items: center;
    padding-left: 5px;
    overflow: hidden;
    background-color: transparent;
    border: 0;

    &[aria-checked='true'] > div:nth-child(1) {
        border: 2px solid ${color.Blue.B60};

        > div {
            transform: translate(-50%, -50%) scale(0.5);
            min-height: 8px;
            min-width: 8px;
            background: ${color.Blue.B60};
        }
    }

    &[disabled] {
        opacity: 0.4;
        pointer-events: none;
    }
`;
WrapperDiv.displayName = 'WrapperDiv';

const RadioBtn = styled.div`
    position: relative;
    height: 16px;
    width: 16px;
    margin-right: 10px;
    border: 2px solid ${color.Grey.G30};
    box-sizing: border-box;
    border-radius: 50%;
    background-color: white;
    pointer-events: none;
`;
RadioBtn.displayName = 'RadioBtn';

const RadioCheckedIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    height: 16px;
    width: 16px;
    box-sizing: border-box;
    border-radius: 50%;
    background: ${color.Blue.B60};
    pointer-events: none;
    transition: all ease-in-out 0.15s;
`;
RadioCheckedIcon.displayName = 'RadioCheckedIcon';

const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1px;
    color: ${color.Grey.G70};
    pointer-events: none;
    & > span {
        margin-right: 5px;
    }
`;
ContentWrapper.displayName = 'ContentWrapper';

const Caption = styled.div`
    user-select: none;
    color: ${color.Grey.G70};
    font-size: 14px;
    pointer-events: none;
`;
Caption.displayName = 'Caption';

const IconWrapper = styled.div`
    color: ${color.Grey.G70};
    margin-right: 5px;
`;

interface IParentWrapper {
    compact?: boolean;
}

const ParentWrapper = styled.div<IParentWrapper>`
    display: inline-flex;
    gap: 8px;
    align-items: center;

    &[data-orientation='Vertical'] {
        margin-bottom: ${({ compact }) => (compact ? '0' : '10px')};
    }
`;

export interface IRadioButtonItemProps {
    caption: string;
    value: number | string;
    stackOrientation?: StackOrientation;
    icon?: Icons;
    disabled?: boolean;
    compact?: boolean;
}

export const RadioButtonItem: React.FC<IRadioButtonItemProps> = ({ caption, value, stackOrientation, icon, disabled, compact, children }) => {
    return (
        <ParentWrapper data-orientation={stackOrientation} compact={compact}>
            <WrapperDiv type="button" role="radio" aria-checked={false} disabled={disabled} data-value={value}>
                <RadioBtn>
                    <RadioCheckedIcon />
                </RadioBtn>
                <ContentWrapper>
                    {icon ? (
                        <IconWrapper>
                            <Icon height="24px" width="24px" icon={icon} />
                        </IconWrapper>
                    ) : null}
                    <Caption>{caption}</Caption>
                </ContentWrapper>
            </WrapperDiv>
            {children}
        </ParentWrapper>
    );
};
